import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { PageContainer, PageHeadline } from '@/components/layout';

function HomePage() {
  const { t } = useTranslation();

  return (
    <PageContainer>
      {/* Headline, key figures and welcome card */}
      <div className="space-y-6">
        <PageHeadline
          headlineKey="sidebar.dashboard"
          subheadlineKey={t('app.name') + ' - Industrial device management'}
        />


        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          <div className="rounded-xl border border-gray-200 bg-white p-4 dark:border-neutral-700 dark:bg-neutral-800">
            <div className="flex items-center gap-x-2">
              <p className="text-xs uppercase text-gray-500 dark:text-neutral-500">
                {t('sidebar.myDevices')}
              </p>
            </div>
            <div className="mt-1 flex items-center gap-x-2">
              <h3 className="text-xl font-medium text-gray-800 dark:text-neutral-200">
                12
              </h3>
            </div>
          </div>

          <div className="rounded-xl border border-gray-200 bg-white p-4 dark:border-neutral-700 dark:bg-neutral-800">
            <div className="flex items-center gap-x-2">
              <p className="text-xs uppercase text-gray-500 dark:text-neutral-500">
                {t('sidebar.tools')}
              </p>
            </div>
            <div className="mt-1 flex items-center gap-x-2">
              <h3 className="text-xl font-medium text-gray-800 dark:text-neutral-200">
                5
              </h3>
            </div>
          </div>

          <div className="rounded-xl border border-gray-200 bg-white p-4 dark:border-neutral-700 dark:bg-neutral-800">
            <div className="flex items-center gap-x-2">
              <p className="text-xs uppercase text-gray-500 dark:text-neutral-500">
                {t('sidebar.companies')}
              </p>
            </div>
            <div className="mt-1 flex items-center gap-x-2">
              <h3 className="text-xl font-medium text-gray-800 dark:text-neutral-200">
                8
              </h3>
            </div>
          </div>

          <div className="rounded-xl border border-gray-200 bg-white p-4 dark:border-neutral-700 dark:bg-neutral-800">
            <div className="flex items-center gap-x-2">
              <p className="text-xs uppercase text-gray-500 dark:text-neutral-500">
                {t('sidebar.user')}
              </p>
            </div>
            <div className="mt-1 flex items-center gap-x-2">
              <h3 className="text-xl font-medium text-gray-800 dark:text-neutral-200">
                24
              </h3>
            </div>
          </div>
        </div>

        <div className="rounded-xl border border-gray-200 bg-white p-6 dark:border-neutral-700 dark:bg-neutral-800">
          <h2 className="mb-4 text-lg font-semibold text-gray-800 dark:text-white">
            Welcome to Eurodima
          </h2>
          <p className="text-gray-500 dark:text-neutral-400">
            Industrial web application for managing Eurodima devices and tools.
          </p>
        </div>
      </div>
    </PageContainer>
  );
}

export const Route = createFileRoute('/_app/')({
  component: HomePage,
});
